import {Component, Input, OnInit} from '@angular/core';
import {GenericNotification} from '../../models/notification/generic-notification.model';
import {CommonUtils} from '../../utils/common';
import {PopoverController} from '@ionic/angular';
import {AppStateService} from '../../providers/app-state.service';

@Component({
  selector: 'app-notifications-popover',
  templateUrl: './notifications-popover.component.html',
  styleUrls: ['./notifications-popover.component.scss'],
})
export class NotificationsPopoverComponent implements OnInit {
  @Input() notifications: GenericNotification[];

  private notificationsList: GenericNotification[];

  constructor(
    public commonUtils : CommonUtils,
    private popoverController: PopoverController,
    private appStateService: AppStateService
  ) { }

  ngOnInit() {
    this.notificationsList = this.notifications;
  }

  dismissNotification(event, notificationID: string) {
    this.commonUtils.getStorageObject<GenericNotification[]>('notifications').then(notificationList => {
      if (notificationList) {
        for (let i = 0; i < notificationList.length; i++) {
          if (notificationList[i].id === notificationID) {
            notificationList.splice(i, 1);
          }
        }

        event.stopPropagation();

        this.commonUtils.setStorageObject('notifications', notificationList).then(ok => {
          this.appStateService.updateNotificationsSubject(notificationList);
        });
      }
    });
  }

  goToCmd(notification) {
    const notificationObj: GenericNotification = this.commonUtils.bestTypedCopyEver<GenericNotification>(new GenericNotification(), notification);
    if (notificationObj) {
      this.commonUtils.goToCmd(notificationObj.getGotoCommands(), () => {
        this.commonUtils.getStorageObject<GenericNotification[]>('notifications').then(notificationList => {
          if (notificationList) {
            for (let i = 0; i < notificationList.length; i++) {
              if (notificationList[i].id === notificationObj.id) {
                notificationObj.wasSeen = true;
                notificationList.splice(i, 1, notificationObj);
              }
            }

            this.commonUtils.setStorageObject('notifications', notificationList).then(ok => {
              this.appStateService.updateNotificationsSubject(notificationList);
            });
          }
        });

        this.popoverController.dismiss();
      });
    }
  }
}
